import RestorePasswordScreen from './RestorePasswordScreen';

import './RestorePasswordScreen.scss';

export default RestorePasswordScreen;
